import { render } from "./TagUpdatePost.vue?vue&type=template&id=38c962a9&scoped=true"
import script from "./TagUpdatePost.vue?vue&type=script&lang=js"
export * from "./TagUpdatePost.vue?vue&type=script&lang=js"

import "./TagUpdatePost.vue?vue&type=style&index=0&id=38c962a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c962a9"]])

export default __exports__